import { WithPermissions } from '@Components/common/with-permissions'
import { AuthScopes } from '@Generated/back-office-client/src'
import { Button, Flex, Text, TextField } from '@radix-ui/themes'
import { BrandingPreview } from '../components/branding-preview'
import { ColorInput } from '../components/color-input'
import { APPEARANCE_SAVED_MESSAGE } from '../constants'
import { BrandingErrors, ColorField, GameBrandingFormData } from '../types'
import '../styles.scss'

type AppearanceSectionProps = {
  gameName: string
  form: GameBrandingFormData
  errors: BrandingErrors
  isSaving: boolean
  saveError: string | null
  isSaved: boolean
  onChange: (form: GameBrandingFormData) => void
  onBlurColor: (field: ColorField) => void
  onSave: () => void
}

export const AppearanceSection = ({
  gameName,
  form,
  errors,
  isSaving,
  saveError,
  isSaved,
  onChange,
  onBlurColor,
  onSave,
}: AppearanceSectionProps) => {
  return (
    <Flex direction="column" gap="3">
      <Text size="3" weight="bold">
        Appearance
      </Text>

      <Flex direction="column" gap="2">
        <label htmlFor="game-logo-url">
          <Text size="2" weight="medium">
            Logo URL
          </Text>
        </label>
        <TextField.Root
          id="game-logo-url"
          value={form.logoUrl}
          onChange={(e) => onChange({ ...form, logoUrl: e.target.value })}
        />
      </Flex>

      <ColorInput
        id="game-brand-color"
        label="Brand color"
        value={form.brandColorPrimary}
        error={errors.brandColorPrimary}
        onChange={(value) => onChange({ ...form, brandColorPrimary: value })}
        onBlur={() => onBlurColor('brandColorPrimary')}
      />

      <ColorInput
        id="game-font-color"
        label="Font color"
        value={form.fontColorPrimary}
        error={errors.fontColorPrimary}
        onChange={(value) => onChange({ ...form, fontColorPrimary: value })}
        onBlur={() => onBlurColor('fontColorPrimary')}
      />

      <ColorInput
        id="game-special-ball-color"
        label="Special ball color"
        value={form.specialBallColor}
        error={errors.specialBallColor}
        onChange={(value) => onChange({ ...form, specialBallColor: value })}
        onBlur={() => onBlurColor('specialBallColor')}
      />

      <BrandingPreview gameName={gameName} form={form} />

      <WithPermissions requiredPermissions={AuthScopes.writegames}>
        <Flex direction="column" gap="2">
          <Flex>
            <Button onClick={onSave} disabled={isSaving}>
              {isSaving ? 'Saving...' : 'Save Appearance'}
            </Button>
          </Flex>
          {saveError && (
            <Text size="1" color="red">
              {saveError}
            </Text>
          )}
          {isSaved && (
            <Text size="1" color="green">
              {APPEARANCE_SAVED_MESSAGE}
            </Text>
          )}
        </Flex>
      </WithPermissions>
    </Flex>
  )
}
